import TextCell from 'components/TextCell';
import type { ManagedOemSegmentType } from '../..';

interface CellProps {
  rowData: ManagedOemSegmentType;
}

export default function IdCell({ rowData: { id } }: CellProps) {
  return <TextCell text={id} />;
}
